<template>
  <div class="page">
    <header>
      <NavBar :title="lang('积分明细')"> </NavBar>
      <Filter
        :tab-index="curTabIndex"
        :show="show"
        @change-tab="(value) => changeTab(value)"
        @show-filter="showFilter"
      />
    </header>
    <div class="main">
      <van-dialog
        v-model:show="showConfirm"
        :title="lang('上传确认图片')"
        show-cancel-button
        :confirm-button-color="'red'"
        :confirm-button-text="lang('确认')"
        :cancel-button-text="lang('取消')"
        @cancel="cancel"
        @confirm="confirmCommit"
      >
        <div class="imageBox">
          <div
            v-for="(item, i) in confirmImage"
            :key="i"
            class="imageContainer"
          >
            <div class="icon" @click="del(i)">
              <van-icon name="cross" />
            </div>
            <van-image :src="item.url" @click="previewFn(i)" />
          </div>
          <div v-if="confirmImage.length < 3" class="upload" @click="upLoad">
            <van-icon name="plus" size="20px" />
          </div>
        </div>
      </van-dialog>
      <van-popup
        v-model:show="show"
        round
        class="pop"
        position="bottom"
        :style="{ height: 'auto', padding: '20px 16px' }"
      >
        <filter-status :tab="curTabIndex" @click="filterStatusFn" />
        <van-picker-group
          :title="lang('预约日期')"
          class="group"
          :tabs="[
            lang('From') + ' ' + startDate.join('-'),
            lang('到') + ' ' + endDate.join('-')
          ]"
          @confirm="onConfirm"
          @cancel="onCancel"
        >
          <van-date-picker
            v-model="startDate"
            :min-date="minDate"
            :max-date="maxDate"
          />
          <van-date-picker
            v-model="endDate"
            :min-date="minDate"
            :max-date="maxDate"
          />
          <template #toolbar>
            <p class="time">{{ lang('时间') }}</p>
          </template>
        </van-picker-group>
        <bottom @confirm="onConfirm()" @reset="reset()" />
      </van-popup>
      <div class="pullList">
        <PullRefresh
          v-model:refreshing="refreshing"
          :scroll-height="'100%'"
          :loading-text="''"
          class="pull"
          @on-refresh="refreshFn"
        >
          <van-list
            v-show="curTabIndex === 0"
            v-model:loading="loading"
            :finished="finished"
            :loading-text="' '"
            :finished-text="lang('没有更多了')"
            :offset="10"
            @load="loadMore"
          >
            <div v-for="(item, index) in result" :key="index" class="item">
              <TimeLine v-if="item.time" :title="item.time" />
              <exchange-records
                :data="item"
                @refresh-list="refreshFn"
                @confirm="confirm"
              />
            </div>
          </van-list>
          <van-list
            v-show="curTabIndex === 1"
            v-model:loading="loading"
            :finished="finished"
            :finished-text="lang('没有更多了')"
            :offset="10"
            :loading-text="' '"
            @load="loadMore"
          >
            <div v-for="(item, index) in result" :key="index" class="item">
              <TimeLine v-if="item.time" :title="item.time" />
              <top-up-records :data="item" @click="toScoreDetail(item)" />
              <Line
                v-if="result.length !== index + 1"
                :style="[{ margin: '0 22px' }]"
              />
            </div>
          </van-list>
          <NoData v-if="finished && dataList.length === 0" />
        </PullRefresh>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import NavBar from '@core/components/NavBar.vue'
import lang from '@/langs'
import Filter from '@/views/score/component/scoreDetail/filter.vue'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, ref, watch } from 'vue'
import ExchangeRecordsList from '@/views/score/component/scoreDetail/exchangeRecordsList.vue'
import TopUpRecordsList from '@/views/score/component/scoreDetail/topUpRecordsList.vue'
import FilterStatus from '@/views/score/component/scoreDetail/filterStatus.vue'
import Bottom from '@/views/score/component/scoreDetail/bottom.vue'
import {
  chargeRecords,
  confirmDelivery,
  scoreRecords
} from '@/api/requests/score'
import { scoreRecordsModel } from '@/model/score/score'
import usePagination from '@core/utils/usePagination'
import PullRefresh from '@core/components/PullRefresh.vue'
import TimeLine from '@/views/score/component/scoreDetail/timeLine.vue'
import ExchangeRecords from '@/views/score/component/scoreDetail/exchangeRecords.vue'
import TopUpRecords from '@/views/score/component/scoreDetail/topUpRecords.vue'
import Line from '@core/components/line.vue'
import { getDateBeforeDays, getFormattedDate } from '@core/utils/aboutDate'
import NoData from '@core/components/NoData.vue'
import { groupDataByDate, groupDataByDate2 } from '@/views/score/utils/dealData'
import { getPhoto } from '@core/utils/nativeAPI'
import { uploadFile } from '@/utils/imageUpload'
import { showImagePreview, showToast } from 'vant'
import { useUserStore } from '@core/stores/user'
import dayjs from 'dayjs'
const route = useRoute()
const router = useRouter()
const curTabIndex = ref(Number(route.query.type) || 0)
const minDate = ref(new Date(2020, 0, 1))
const maxDate = ref(new Date())
const show = ref(false)
const startDate = ref(getDateBeforeDays(31))
const endDate = ref(getFormattedDate())
const status = ref(0)
const showConfirm = ref(false)
const confirmImage = ref([])
const { nativeInfo } = useUserStore()
const stationCode = nativeInfo.stationCode
const previewFn = (index: number) => {
  if (confirmImage.value.length === 0) return
  showImagePreview({
    images: confirmImage.value.map((e) => e?.url || ''),
    startPosition: index
  })
}
const cancel = () => {
  showConfirm.value = false
  confirmImage.value = []
}
const id = ref('')
const confirm = (value: string) => {
  showConfirm.value = true
  confirmImage.value = []
  id.value = value
}
const confirmCommit = () => {
  confirmDelivery({
    id: id.value,
    stationCode,
    receiptTime: dayjs().format('YYYY-MM-DD hh:mm:ss'),
    materialReceiptPhotos: confirmImage.value.map((e) => e?.path || '')
  })
    .then((res) => {
      if (res.code === 1) {
        showToast(lang('已确认到达'))
        refreshFn()
      }
    })
    .finally(() => {
      cancel()
    })
}
const del = (index: number) => {
  confirmImage.value.splice(index, 1)
}
const upLoad = () => {
  getPhoto().then((value) => {
    const temp = JSON.parse(value)
    uploadFile(
      temp[0].data,
      temp[0].name,
      (res, data) => {
        if (res) {
          // showToast(lang('上传成功'))
          const temp = { path: data?.path ?? '', url: data?.url ?? '' }
          confirmImage.value.push(temp)
          console.log(data)
        } else {
          showToast(lang('上传失败'))
        }
      },
      (loading) => {}
    )
  })
}
const filterStatusFn = (value: number) => {
  status.value = value
}
const onConfirm = () => {
  setFunc(apiFn())
  fetchPageData(paramValue())
  show.value = false
}

const onCancel = () => {}
const changeTab = (value: number) => {
  curTabIndex.value = value
  status.value = 0
  startDate.value = getDateBeforeDays(31)
  endDate.value = getFormattedDate()
  setFunc(apiFn())
  fetchPageData(paramValue())
}

const apiFn = () => {
  if (curTabIndex.value === 0) {
    return scoreRecords
  } else {
    return chargeRecords
  }
}
const {
  param,
  dataList,
  loading,
  finished,
  refreshing,
  fetchPageData,
  refreshFn,
  loadMore,
  setFunc
} = usePagination(apiFn())

// 按年月日分类
const result = ref([])
watch(
  dataList,
  (value) => {
    if (curTabIndex.value === 0) {
      result.value = groupDataByDate2(value) //处理兑换记录的
    } else {
      result.value = groupDataByDate(value)
    }
  },
  {
    deep: true
  }
)

const paramValue = (): scoreRecordsModel => {
  let obj = {
    applyEndTime: endDate.value.join('-') + ' 23:00:00',
    applyStartTime: startDate.value.join('-') + ' 00:00:00',
    verifyStatus: status.value
  }
  if (status.value === 0) {
    delete obj.verifyStatus
  }
  return obj
}
const showFilter = () => {
  show.value = !show.value
}
const toScoreDetail = (item) => {
  router.push({
    path: '/scoreCharge',
    query: { id: item.id, isH5: 'true' }
  })
}
onMounted(() => {
  fetchPageData(paramValue())
})
const reset = () => {
  show.value = false
}
</script>
<script lang="ts">
export default {
  name: 'ScoreDetail'
}
</script>
<style scoped lang="less">
.page {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: scroll;
    .imageBox {
      display: flex;
      flex-direction: row;
      padding: 18px;
      flex-wrap: wrap;
      .imageContainer {
        position: relative;
        .icon {
          position: absolute;
          top: 0;
          right: 8px;
          z-index: 9;
          background: rgba(45, 44, 44, 0.3);
          padding: 3px 5px;
          color: #fff;
        }
      }
      :deep(.van-image) {
        width: 80px;
        height: 80px;
        border-radius: 8px;
        margin-right: 8px;
      }
      .upload {
        width: 80px;
        height: 80px;
        background: rgba(114, 114, 114, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
      }
    }
    :deep(.van-tabs) {
      .van-tabs__wrap {
        display: flex;
        flex-direction: row;
        .van-tabs__nav {
          display: flex;
          flex-direction: row;
          flex: 1;
          .van-tab {
            flex: 2;
            color: rgba(60, 60, 60, 1);
            font-size: 17px;
          }
          .van-tabs__line {
            background: red;
          }
          .van-picker-group__tab-title {
            margin-right: 0;
          }
        }
      }
    }
    .time {
      color: rgba(60, 60, 60, 1);
      font-size: 14px;
      font-weight: 500;
    }
    .pop {
      display: flex;
      flex-direction: column;
      .group {
        flex: 1;
        padding-bottom: 28px;
      }
    }
    .pullList {
      //flex: 1;
      height: 100%;
    }
  }
}
</style>
